export const getExtraProperty = (extraProperties, key, defaultValue = '') => {
    var _a;
    try {
        const value = (_a = extraProperties === null || extraProperties === void 0 ? void 0 : extraProperties.find(xp => xp.key === key)) === null || _a === void 0 ? void 0 : _a.value;
        return JSON.parse(value);
    }
    catch (_b) {
        return defaultValue;
    }
};
//# sourceMappingURL=properties.js.map